import React from 'react';

import { FilterCardapioItem } from './FilterCardapioItem';

import { IFilterCardapioItem } from './interfaces';

export const Container: React.FC<IFilterCardapioItem> = ({
  id,
  isSelected,
  children,
  ...rest
}) => {
  return (
    <>
      <FilterCardapioItem
        id={`filterCardapioItem@${id}`}
        data-testid={`filterCardapioItem@${id}`}
        isSelected={isSelected}
        {...rest}
      >
        {children}
      </FilterCardapioItem>
    </>
  );
};
